import { startsWith as _startsWith } from 'lodash';

import { BLOCK_PREFIX } from '../name';

export default (entityName: string): boolean => {
    return _startsWith(entityName, BLOCK_PREFIX);
};
